import UserSettings from '.';

export const UserSettingsRouter = [
  {
    path: '/account-settings',
    name: 'UserSettings',
    component: UserSettings,
  },
];

export default UserSettingsRouter;
